import React from 'react'
import AdjustIcon from '@mui/icons-material/Adjust';

const NewIcon = () => {
  return (
<AdjustIcon sx={{ color: 'orange', fill: 'currentcolor' }} ></AdjustIcon>
  )
}

export default NewIcon